export const GET_ASSESSMENT_PARTICIPANT_INFO =
  "GET_ASSESSMENT_PARTICIPANT_INFO";
